import { connect } from "react-redux";
import { withRouter } from "tools/routerCompat";
import {
  agentCreate
} from "../../../actions/agent";
import {
  getMajorCompanies
} from "../../../actions/customer";
import { CustomerAgentProfile } from "../../../components/Customer/Agent";
import responseHandler from "responseHandler";

const mapStateToProps = (state) => {
  return {
    agentDetails: state.customer.agentDetails,
    majorCompanies: state.customer.majorCompanies,
    isCreating: true,
    isSavingAgent: state.customer.isSavingAgent
  };
};

const mapDispatchToProps = dispatch => ({
  agentCreate(agentInfo) {
    dispatch(agentCreate(agentInfo));
  },
  getMajorCompanies() {
    dispatch(getMajorCompanies());
  },
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CustomerAgentProfile));
